import type {
  LoanApplication,
  LoanBorrower,
} from '@/types/LoanApplicationType';

export function applicationHasCoBorrower(
  app: Pick<LoanApplication, 'borrowers'>
): boolean {
  return (app.borrowers ?? []).some((b) => b.role === 'coBorrower');
}

export function coBorrowerFromApplication(
  app: Pick<LoanApplication, 'borrowers'>
): LoanBorrower | undefined {
  return app.borrowers?.find((b) => b.role === 'coBorrower');
}

export function borrowersWithoutCoBorrower(
  borrowers: LoanBorrower[] | undefined
): LoanBorrower[] {
  return (borrowers ?? []).filter((b) => b.role !== 'coBorrower');
}
